import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export const store = new Vuex.Store({
    state: {
        package:[
            {id:1,name:"php",updateTime:"2022-02-02"},
            {id:2,name:"js",updateTime:"2022-02-02"},
            {id:3,name:"jquery",updateTime:"2022-02-02"},
            {id:4,name:"python",updateTime:"2022-02-02"}
        ],
        total:10,
        curent:1
    },
    mutations: {
        getPackageList(state){
            state.count++;
        }
    },
    actions:{
        getPackageList(context){
            context.commit("getPackageList")
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js